// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1___192735641f5f9c648b7","cls2":"SocialActionsMenu-cls2__dd5bd990ae9b543ad069 SocialActionsMenu-cls1___192735641f5f9c648b7"};